import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Radio,
  FormGroup,
  Checkbox,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import { put, get } from "../../../../utils/api";
import styles from "../../../../styles/gri/general.module.css";
import AddmultipleTables from "./Tables";
import GRISidebar from "../../../../Layout/GRISidebar";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI302_3 = ({ hide }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    product: "",
    service: "",
    sales: "",
    organizationspecificmetrics: "",
    engeryInclude: [],
    energyConsumptionWithinOrg: "",
  });
  const lists = ["Fuel", "Electricity", "Heating", "Cooling", "Steam"];
  const radios = ["Within The Organization", "Outside", "Both"];
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  React.useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  const fetchData = async () => {
    await get(`/gri/get?Id=${id}&type=GRI300`).then((res) => {
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const response = res?.data?.data?.GRI300?.energyIntensity;
      setFormData({
        product: response?.product,
        service: response?.service,
        sales: response?.sales,
        organizationspecificmetrics: response?.organizationspecificmetrics,
        engeryInclude: response?.engeryInclude,
        energyConsumptionWithinOrg: response?.energyConsumptionWithinOrg,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const inputData = [
    {
      defalut: "Energy consumed per metrics",
      colwidth: "38%",
      //  filedName: "energyConsumption",
      fields: [
        {
          title: "Value",
          //  field: "intensity",
        },
      ],
    },
  ];

  const defaultSegments1 = [
    {
      title: "Product",
      type: "number",
      fieldName: "product",
      placeholder: "Enter Number",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Services",
      type: "number",
      placeholder: "Enter Number",
      fieldName: "service",
      list: ["MJ", "GJ", "TJ"],
    },
    {
      title: "Sales",
      type: "number",
      placeholder: "Enter Number",
      fieldName: "sales",
      list: ["MJ", "GJ", "TJ"],
    },
  ];

  const handleChangeSelectedField = (e) => {
    const { name, value, checked } = e.target;
    setFormData((prev) => {
      // Check if the selected value already exists in the array
      const updatedArray = prev.engeryInclude.includes(value)
        ? prev.engeryInclude.filter((item) => item !== value) // Remove if it exists
        : [...prev.engeryInclude, value]; // Add if it doesn't exist

      return {
        ...prev,
        [name]: updatedArray, // Update the 'engeryInclude' field
      };
    });
  };

  const handleChangeRadio = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeSelect = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value, // If no sub-field, update main field
    }));
  };
  const handleSubmit = async () => {
    if (!disabled) {
      try {
        const res = await put(`/gri/update?Id=${id}`, {
          type: "GRI300",
          submitted302_3: true,
          energyIntensity: { ...formData },
        })
          .then((res) => navigate(`/gri/gri300/302-4/${id}`))
          .catch((err) => console.log(err));
      } catch (error) {
        console.log(error);
        // setsnackOpen({
        //   open: true,
        //   message: error.data.message,
        //   severity: "error",
        // });
      }
    } else {
      navigate(`/gri/gri300/302-4/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      {!hide && <p className={styles.section_heading} style={{ textDecoration: "none" , }}>
        302 : <span className={styles.main_heading_underline}>ENERGY</span>
      </p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        302-3 :{" "}
        <span className={styles.main_heading_underline}>Energy intensity</span>
      </p>
      <AddmultipleTables
        title="a. Energy intensity ratio for the organization."
        inputData={inputData}
        defaultSegments={defaultSegments1}
        // unitsAll={""}
        // disabled={false}
        {...{
          formData,
          setFormData,
          errors,
          setErrors,
          disabled: disabled,
          hide: hide
        }}
      />
      <Box sx={{ mt: 2 }}>
        <p className={styles.ques_heading}>
          {" "}
          b. Organization-specific metrics (denominators)
        </p>
        <Select
          sx={{
            height: "2rem",
            ml: 2,
          }}
          name="organizationspecificmetrics"
          value={formData?.organizationspecificmetrics || ""}
          placeholder="Choose the denominator used for intensity calculation"
          onChange={(e) => handleChangeSelect(e)}
          displayEmpty
          size="small"
          fullWidth
          disabled={disabled}
          // disabled={!data?.[DropDownData?.fieldName]?.[list?.fields]?.active}
        >
          <MenuItem value="">
            Choose the denominator used for intensity calculation 
          </MenuItem>
          {[
            "Units of products",
            "Production volume (metric tons / litres/ MWH)",
            "Size (m2 floor space)",
            "Number of full-time employee",
            "Monetary units ( per rupee revenue )",
          ].map((data, index) => (
            <MenuItem key={index} value={data}>
              {data}
            </MenuItem>
          ))}
        </Select>
      </Box>

      <Box>
        <p className={styles.ques_heading}>
          c. Types of energy included in the intensity ratio
        </p>
        <Box sx={{ marginLeft: "1rem" }}>
          <p className={styles.ques_heading}>
            (i) Which types of energy are included in the intensity ratio?
            (e.g., fuel, electricity, heating, cooling, steam, or all)
          </p>
          <FormGroup sx={{ ml: 2 }}>
            {lists.map((item, index) => (
              <FormControlLabel
                key={index} // Using index as the unique key for each label
                control={
                  <Checkbox
                    value={item}
                    disabled={disabled}
                    name="engeryInclude"
                    onChange={(e) => handleChangeSelectedField(e)}
                    checked={formData?.engeryInclude?.includes(item)}
                  />
                } // Checkbox component
                label={item} // Display the current item as the label
              />
            ))}
          </FormGroup>
        </Box>

        <p className={styles.ques_heading}>
          d. Whether the ratio uses energy consumption within the organization,
          outside of it, or both:
        </p>
        <Box sx={{ marginLeft: "1rem" }}>
          <p className={styles.ques_heading}>
            (i) Does the ratio use energy consumption within the organization,
            outside of it, or both?
          </p>
          <FormGroup
            component="fieldset"
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "16px",
            }}
          >
            <RadioGroup
              aria-label="gender"
              defaultValue="female"
              name="energyConsumptionWithinOrg"
              value={formData?.energyConsumptionWithinOrg || ""}
              style={{ display: "flex", flexDirection: "row" }}
              onChange={handleChangeRadio}
              disabled={disabled}
            >
              {radios.map((item, index) => (
                <FormControlLabel
                  key={index} // Unique key for each label
                  value={item} // Set value to lowercased radio option
                  control={<Radio disabled={disabled} />}
                  label={item}
                />
              ))}
            </RadioGroup>
          </FormGroup>
        </Box>
      </Box>
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};
export default GRI302_3;
